import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/globeIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/landmarkIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/minus.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/plus.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/timeIcon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/img/CertifiedImg.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/logo/ambee-logo-footer.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/logo/arrow-right.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/logo/facebook.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/logo/instagram.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/logo/linkedin.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/logo/X.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/logo/youtube.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/shapes/circle.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/shapes/kite.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/shapes/rectangle.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/AllergyCitySection/AllergyCitySection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExternalSection"] */ "/app/src/components/Cards/ExternalSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Header/AnimationCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/LevelBody.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/tables/ScaleTable.tsx");
